// ─── src/api/ecosystemPerception.ts ──────────────────────────────────────────

import { apiClient } from "./registration";
import type {
  EcosystemFilters,
  EcosystemParams,
  EcosystemResponse,
  EcosystemResponseList,
  EcosystemStats,
} from "../types/ecosystemPerception";
import type { PaginationMeta } from "../types/registration";

const BASE = "/ecosystem-perception";

export interface NormalisedEcosystemResponse {
  data: EcosystemResponse[];
  meta: PaginationMeta;
}

const normalise = (raw: EcosystemResponseList): NormalisedEcosystemResponse => ({
  data: raw.data,
  meta: {
    total:      raw.total,
    page:       raw.page,
    limit:      raw.limit,
    totalPages: Math.ceil(raw.total / raw.limit),
  },
});

export const getEcosystemResponses = async (
  params: EcosystemParams,
): Promise<NormalisedEcosystemResponse> => {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== "" && v !== null),
  );
  const { data } = await apiClient.get<EcosystemResponseList>(BASE, { params: clean });
  return normalise(data);
};

export const getEcosystemStats = async (
  filters: EcosystemFilters = {},
): Promise<EcosystemStats> => {
  const clean = Object.fromEntries(
    Object.entries(filters).filter(([, v]) => v !== undefined && v !== "" && v !== null),
  );
  const { data } = await apiClient.get<EcosystemStats>(`${BASE}/stats`, { params: clean });
  return data;
};

export const deleteEcosystemResponse = async (id: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${id}`);
};
